/**
 * Automatic Client-Side Version Checker & Cache Buster
 * Checks /version.json for app update and reloads the page if a new build is deployed.
 */
export const checkAppVersion = async () => {
  try {
    const publicUrl = process.env.PUBLIC_URL || "";
    const response = await fetch(`${publicUrl}/version.json?t=${Date.now()}`, {
      cache: "no-store",
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
      },
    });

    if (!response.ok) return;

    const data = await response.json();
    const serverVersion = `${data.version}_${data.buildTime}`;
    const localVersion = localStorage.getItem("app_build_version");

    if (!localVersion) {
      localStorage.setItem("app_build_version", serverVersion);
    } else if (localVersion !== serverVersion) {
      console.log("New version detected! Updating app and refreshing cache...");
      localStorage.setItem("app_build_version", serverVersion);

      // Unregister any active service worker caches if supported
      if ("caches" in window) {
        try {
          const cacheKeys = await window.caches.keys();
          await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
        } catch (e) {
          console.warn("Could not clear cache storage:", e);
        }
      }

      // Hard reload page to fetch fresh scripts and styles
      window.location.reload(true);
    }
  } catch (error) {
    // Fail silently so network issues don't disturb user experience
    console.debug("Version check failed:", error);
  }
};
